import { useSelector } from '@tunasong/redux'
import type { ComposerIntent } from '@tunasong/redux'

/**
 * The pending composer intent for THIS agent, or null. Redux transports the
 * intent (see `openAgentComposer`); `AgentChat` copies it into local state and
 * clears it — so a non-null return means "not yet consumed".
 */
export const useComposerIntent = (agentId: string | undefined): ComposerIntent | null =>
  useSelector(state => {
    const intent = state.ui.sidebar.composerIntent
    if (!agentId || !intent || intent.agentId !== agentId) {
      return null
    }
    return intent
  })
